import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, ChevronDown, Menu } from 'lucide-react';
import { motion, useScroll, useSpring } from 'framer-motion';
import FilmDialog from './FilmDialog';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from './ui/dropdown-menu';
import { Sheet, SheetTrigger, SheetContent, SheetTitle, SheetDescription, SheetClose } from './ui/sheet';

const sectors = ['Technology', 'Healthcare', 'Semiconductors'];
const links = [['Solutions', '/#capabilities'], ['Company', '/#who-we-are'], ['Products', '/#products'], ['Partners', '/#partners']];
export default function SiteHeader({ logoUrl }) {
  const location = useLocation();
  const {scrollYProgress}=useScroll(); const progress=useSpring(scrollYProgress,{stiffness:120,damping:30});
  const [open, setOpen] = useState(false);
  useEffect(() => setOpen(false), [location.pathname, location.hash]);
  return <header className="gx-header">
    <motion.div className="reading-progress" style={{scaleX:progress}}/>
    <a className="skip-link" href="#main">Skip to content</a>
    <div className="gx-header-inner">
      <Link className="gx-brand" to="/" aria-label="Genesys Info X home">
        <img src={logoUrl} alt="" width="52" height="52" />
        <span>GENESYS <strong>INFO X</strong><small>ENGINEERING WHAT'S NEXT</small></span>
      </Link>
      <nav className="gx-nav" aria-label="Primary navigation">
        <DropdownMenu><DropdownMenuTrigger className="gx-nav-link">Industries <ChevronDown size={15}/></DropdownMenuTrigger>
          <DropdownMenuContent className="gx-dropdown" align="start" sideOffset={18}>
            {sectors.map(name => <DropdownMenuItem asChild key={name}><Link to={'/' + name.toLowerCase()}>{name}<ArrowUpRight size={16}/></Link></DropdownMenuItem>)}
          </DropdownMenuContent>
        </DropdownMenu>
        {links.map(([label, to]) => <Link key={label} to={to}>{label}</Link>)}
      </nav>
      <FilmDialog/>
      <Link className="gx-contact-link" to="/#contact">Let's talk <ArrowUpRight size={18}/></Link>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild><button className="gx-menu" aria-label="Open navigation"><Menu size={23}/></button></SheetTrigger>
        <SheetContent className="gx-mobile-nav"><SheetTitle>Explore Genesys Info X</SheetTitle><SheetDescription>Industries, capabilities and company.</SheetDescription>
          <nav aria-label="Mobile navigation">{[['Home','/'], ...sectors.map(s=>[s,'/'+s.toLowerCase()]), ...links, ['Contact','/#contact']].map(([label,to])=><SheetClose asChild key={label}><Link to={to}>{label}<ArrowUpRight size={18}/></Link></SheetClose>)}</nav>
        </SheetContent>
      </Sheet>
    </div>
  </header>;
}
